
const initialState = {};

const UiReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'UI':
            //console.log('UiReducer.state', state, action.payload, typeof action.payload == 'object');
            //console.log('UiReducer.action.payload', action.payload);
            return { ...state, ...((typeof action.payload == 'object') ? action.payload : {}) };
        default:
            return state;
    }
}

export default UiReducer;